import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { Badge } from '../../../../Badge';
import { Column, Row } from '../../../../Layout';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
import { CellTextInput } from '../CellTextInput/CellTextInput';
import { asString } from '../cellValues';
export function TextCell(param) {
    let { value, subtitle, badge, emptyText, textSkin, textWeight, multiline = false, dotColor, required = false, tokens, editing, testId } = param;
    const testIds = getTestIds(testId);
    const text = asString(value);
    const subtitleLines = (subtitle !== null && subtitle !== void 0 ? subtitle : []).filter((line)=>line !== '');
    const weight = textWeight !== null && textWeight !== void 0 ? textWeight : 'light';
    if (editing != null) {
        return /*#__PURE__*/ _jsx(CellTextInput, {
            value: text !== null && text !== void 0 ? text : '',
            placeholder: emptyText,
            tokens: tokens,
            editing: editing,
            testId: testIds.editor()
        });
    }
    const valueTypography = /*#__PURE__*/ _jsx(Typography, {
        ellipsis: !multiline,
        className: multiline ? styles.multiline : 'dt-cell-value',
        tooltipProps: {
            enableOnMobile: true
        },
        weight: weight,
        skin: text == null ? 'disabled' : textSkin,
        testId: testId,
        children: text !== null && text !== void 0 ? text : emptyText
    });
    const withRequiredMark = required ? /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 4,
        children: [
            valueTypography,
            /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                skin: "error",
                weight: weight,
                children: "*"
            })
        ]
    }) : valueTypography;
    const renderedValue = badge == null ? withRequiredMark : /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 8,
        children: [
            withRequiredMark,
            /*#__PURE__*/ _jsx(Badge, {
                rounded: true,
                outlined: true,
                size: "small",
                testId: testIds.badge(),
                children: badge
            })
        ]
    });
    const withDot = dotColor == null ? renderedValue : /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 8,
        className: styles.dotted,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.dot,
                style: {
                    background: dotColor
                }
            }),
            renderedValue
        ]
    });
    if (subtitleLines.length === 0) return withDot;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 0,
        className: styles.stacked,
        children: [
            renderedValue,
            /*#__PURE__*/ _jsx(Column, {
                gap: 0,
                testId: testIds.subtitle(),
                children: subtitleLines.map((line, index)=>/*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        variant: "paragraph2",
                        skin: "secondary",
                        testId: testIds.subtitleLine(index),
                        children: line
                    }, index))
            })
        ]
    });
}
